// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"3529ca48","488":"75f1601f"}[chunkId] + ".chunk.js";
};